import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { SrcSet } from './picture.module'
import { ObjectUtils } from '../../../../shared/utils/object-utils'
import { Image } from '../../types'

@Component({
  selector: 'mb-picture',
  templateUrl: './picture.component.html',
  styleUrls: ['./picture.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PictureComponent {

  @Input() srcSet: SrcSet[] = []
  @Input() imgClass?: string
  @Input() pictureClass?: string
  @Input() dataCy?: string
  @Input() dataLoaded?: boolean
  @Input() dataPlaceholderBackground?: string
  @Input() width: number | undefined | null
  @Input() height: number | undefined | null

  image: Image | undefined

  @Input() set img (image: Image | undefined) {
    this.image = image
  }

  get img (): Image | undefined {
    return this.image
  }

  getImageUrl (srcSet: SrcSet): string {
    const img = this.img as any
    const source1x = (srcSet?.src === 'original' ? srcSet?.src : `${srcSet?.src || ''}`) as string
    const source2x = (srcSet?.src === 'original' ? srcSet?.src : `${srcSet?.src ? srcSet?.src + '2x' : ''}`) as string
    const noImageType = this.img?.mime === 'image/svg+xml' || this.img?.mime === 'image/gif' || srcSet?.noWebp
    let url1x = (srcSet?.url1x || (img?.[source1x] ?? ''))
    url1x += (noImageType) || url1x.includes('-F') ? '' : '-FJPG'
    let url2x = (srcSet?.url2x || (img?.[source2x] ?? ''))
    url2x += noImageType || url2x.includes('-F') ? '' : '-FJPG'
    return this.getCombineImageUrl(url1x, url2x)
  }

  getImageUrlWebP (srcSet: SrcSet): string {
    const img = this.img as any
    const source1x = (srcSet?.src === 'original' ? srcSet?.src : `${srcSet?.src || ''}`) as string
    const source2x = (srcSet?.src === 'original' ? srcSet?.src : `${srcSet?.src + '2x' || ''}`) as string
    const noImageType = this.img?.mime === 'image/svg+xml' || this.img?.mime === 'image/gif' || srcSet?.noWebp
    let url1x = (srcSet?.url1x ? `${srcSet?.url1x}` : img?.[source1x] ?? '')
    url1x += noImageType || url1x.includes('-F') ? '' : '-FWEBP'
    let url2x = (srcSet?.url2x ? `${srcSet.url2x}` : img?.[source2x] ?? '')
    url2x += noImageType || url2x.includes('-F') ? '' : '-FWEBP'
    return this.getCombineImageUrl(url1x, url2x)
  }

  getCombineImageUrl (url1: string, url2: string): string {
    return ObjectUtils.getCombinedImageUrl(url1, url2)
  }
}
